import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Router, RouterProvider, useNavigate } from "react-router-dom";
import router from "./routes";
import NetworkSpeedAlert from "./Components/NetworkSpeedAlert/NetworkSpeedAlert";
import "antd/dist/reset.css";
import { message } from "antd";
import { MessageProvider } from "./Components/MessageProvider/MessageProvider";
import { IoMdArrowBack } from "react-icons/io";
import Errors from "./Pages/Errors/Errors";
import { ErrorBoundary } from "react-error-boundary";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<Errors />}>
      <MessageProvider>
        <button
          onClick={() => {
            window.history.back();
          }}
          className="absolute left-[10px] top-[10px] shadow-lg md:block p-2 rounded-lg hidden lg:block"
        >
          <IoMdArrowBack />
        </button>
        <RouterProvider router={router}>
          <NetworkSpeedAlert />
        </RouterProvider>
      </MessageProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
